var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.744 19.999C21.986 19.999 22.994 21.008 22.994 22.25L22.993 23.372C23.145 26.127 21.025 27.5 17.09 27.5C13.167 27.5 11 26.146 11 23.411V22.25C11 21.008 12.007 19.999 13.25 19.999H20.744Z",
    fill: "#44A6E0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18.502C19.0716 18.502 20.751 16.8226 20.751 14.751C20.751 12.6794 19.0716 11 17 11C14.9284 11 13.249 12.6794 13.249 14.751C13.249 16.8226 14.9284 18.502 17 18.502Z",
    fill: "#44A6E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7441 19.999C27.9851 19.999 28.9931 21.008 28.9931 22.25V23.039C29.1291 25.511 27.2531 26.749 23.8271 26.749C23.3631 26.749 22.9241 26.725 22.5161 26.683C23.3221 25.939 23.7521 24.931 23.7491 23.655L23.7401 23.331L23.7441 22.25C23.7441 21.353 23.3501 20.549 22.7261 19.999H26.7441Z",
    fill: "#0270B2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.499 18.5C26.1559 18.5 27.499 17.1569 27.499 15.5C27.499 13.8431 26.1559 12.5 24.499 12.5C22.8422 12.5 21.499 13.8431 21.499 15.5C21.499 17.1569 22.8422 18.5 24.499 18.5Z",
    fill: "#0270B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.2c79fae621691d70d9eadf7b03f1ccb7.svg";
export { ForwardRef as ReactComponent };